export default function toDateTimeLong(dateFilter, Authentication) {
  'ngInject';

  return function link(date) {
    const format = Authentication.user.settings.usTimeFormat
      ? "EEEE, MMMM dd, yyyy 'at' h:mm a"
      : "EEEE dd MMMM yyyy 'at' H:mm";
    return dateFilter(date, format);
  };
}
